import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@js/common/request-flow-triggers'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { Map } from '@js/ancient-code/map'

import ProximityCheck from '@f/components/ProximityCheck'

void (function () {
  let map = new Map(document.querySelector('.js-vendor-offices-map'))

  // postcode highlight
  const postcodes = SherlockContainer.deliveryRegions.map(region =>
    region.slice(3, 5)
  )

  map.highlightZipCodeAreas(postcodes)

  let reqBtns = document.querySelectorAll('.js-request-button')
  if (reqBtns) {
    for (let i = 0; i < reqBtns.length; i++) {
      reqBtns[i].dataset.requestType = 'vendor-detail-offices-form'
    }
  }
})()

/* Proximity Check */
void (function () {
  const mountPoints = document.querySelectorAll('.js-proximity')
  for (const mountPoint of mountPoints) {
    const root = createRoot(mountPoint)
    root.render(
      <ProximityCheck
        deliveryRegions={
          window.SherlockContainer.deliveryRegions ||
          window.SherlockContainer.details.deliveryRegions
        }
        alternativeMessage={mountPoint.dataset.hasOwnProperty(
          'alternativeMessage'
        )}
        vendorName={mountPoint.dataset.vendorName}
        version='text'
      />
    )
  }
})()
